import { Controller } from "@hotwired/stimulus"
import { showElement, hideElement } from "@uenf/layout"

const isVisible = (element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;

export default class extends Controller {
  static targets = ["input", "message", "panel"]

  connect() {
    // O nested_form adiciona um conjunto inserindo nós e remove um deles pondo
    // display:none, sem disparar evento algum. Observar a árvore cobre os dois casos —
    // e o `change` do autocomplete, já declarado na view, continua valendo.
    this.observer = new MutationObserver(() => this.change())
    this.observer.observe(this.element, {
      childList: true, subtree: true, attributes: true, attributeFilter: ["style"]
    })
    this.change()
  }

  disconnect() {
    this.observer.disconnect()
  }

  change() {
    let message = "Com o cadastro atual, o aluno cumprirá o requisito desta disciplina <strong>SE</strong>"

    const conjuntos = this.inputTargets
      .filter(isVisible)
      .map(autocompleteElement => Array.from(autocompleteElement.selectedOptions).map(option => option.text))
      .filter((array) => array.length > 0)

    if (conjuntos.length == 0) {
      this.exibir("")
    } else if (conjuntos.length == 1) {
      const conjunto = conjuntos[0]
      if (conjunto.length == 1) {
        message += ' o aluno cursar a disciplina '
      } else {
        message += ' o aluno cursar <strong>TODAS</strong> as disciplinas a seguir: '
      }
      message += `<strong>${conjunto.join(", ")}</strong>.`
      this.exibir(message)
    } else {
      message += ' o aluno cumprir <strong>UMA</strong> das seguintes condições:'
      message += '<ul>'
      for (const conjunto of conjuntos) {
        message += '<li>'
        if (conjunto.length == 1) {
          message += ' o aluno cursar a disciplina '
        } else {
          message += ' o aluno cursar <strong>TODAS</strong> as disciplinas a seguir: '
        }
        message += `<strong>${conjunto.join(", ")}</strong>.`
        message += '</li>'
      }
      message += '</ul>'
      this.exibir(message)
    }
  }

  // Escrever aqui dentro dispara o próprio observer. Sair cedo quando a mensagem não
  // mudou faz a segunda passagem não escrever nada, e o ciclo termina.
  exibir(message) {
    if (message === this.ultimaMensagem) return

    this.ultimaMensagem = message
    this.messageTarget.innerHTML = message
    message ? showElement(this.panelTarget) : hideElement(this.panelTarget)
  }
}
